export default __webpack_public_path__ + "roboto-v27-latin-700italic.ae9579bbdaa96703f7dfd5f2b712dc58.ttf";